module.exports = __webpack_public_path__ + "staticcomp/img/top.d8f845c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/4/top.jpg
// module id = KQMP
// module chunks = 39